/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      email
      name
      role
      phone
      address
      cart {
        nextToken
        __typename
      }
      orders {
        nextToken
        __typename
      }
      bookings {
        nextToken
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      favorites {
        nextToken
        __typename
      }
      blogs {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        email
        name
        role
        phone
        address
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCategory = /* GraphQL */ `
  query GetCategory($id: ID!) {
    getCategory(id: $id) {
      id
      name
      description
      isActive
      displayOrder
      products {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCategories = /* GraphQL */ `
  query ListCategories(
    $filter: ModelCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCategories(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        isActive
        displayOrder
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getProduct = /* GraphQL */ `
  query GetProduct($id: ID!) {
    getProduct(id: $id) {
      id
      name
      description
      shortDescription
      categoryId
      category {
        id
        name
        description
        isActive
        displayOrder
        createdAt
        updatedAt
        __typename
      }
      price
      discountPrice
      stock
      sku
      weight
      dimensions
      isActive
      isFeatured
      tags
      nutritionalInfo
      farmingMethod
      harvestDate
      expiryDate
      images {
        nextToken
        __typename
      }
      videos {
        nextToken
        __typename
      }
      variants {
        nextToken
        __typename
      }
      cartItems {
        nextToken
        __typename
      }
      orderItems {
        nextToken
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      featuredProducts {
        nextToken
        __typename
      }
      favorites {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listProducts = /* GraphQL */ `
  query ListProducts(
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getProductImage = /* GraphQL */ `
  query GetProductImage($id: ID!) {
    getProductImage(id: $id) {
      id
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      url
      altText
      isPrimary
      order
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listProductImages = /* GraphQL */ `
  query ListProductImages(
    $filter: ModelProductImageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductImages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        productId
        url
        altText
        isPrimary
        order
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getProductVideo = /* GraphQL */ `
  query GetProductVideo($id: ID!) {
    getProductVideo(id: $id) {
      id
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      url
      title
      description
      thumbnail
      duration
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listProductVideos = /* GraphQL */ `
  query ListProductVideos(
    $filter: ModelProductVideoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductVideos(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        productId
        url
        title
        description
        thumbnail
        duration
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getProductVariant = /* GraphQL */ `
  query GetProductVariant($id: ID!) {
    getProductVariant(id: $id) {
      id
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      name
      price
      stock
      sku
      cartItems {
        nextToken
        __typename
      }
      orderItems {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listProductVariants = /* GraphQL */ `
  query ListProductVariants(
    $filter: ModelProductVariantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductVariants(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        productId
        name
        price
        stock
        sku
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFeaturedProduct = /* GraphQL */ `
  query GetFeaturedProduct($id: ID!) {
    getFeaturedProduct(id: $id) {
      id
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      displayOrder
      isActive
      startDate
      endDate
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listFeaturedProducts = /* GraphQL */ `
  query ListFeaturedProducts(
    $filter: ModelFeaturedProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFeaturedProducts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productId
        displayOrder
        isActive
        startDate
        endDate
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCart = /* GraphQL */ `
  query GetCart($id: ID!) {
    getCart(id: $id) {
      id
      userId
      user {
        id
        email
        name
        role
        phone
        address
        createdAt
        updatedAt
        __typename
      }
      sessionId
      items {
        nextToken
        __typename
      }
      subtotal
      tax
      shipping
      total
      discountCode
      discountAmount
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCarts = /* GraphQL */ `
  query ListCarts(
    $filter: ModelCartFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCarts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        sessionId
        subtotal
        tax
        shipping
        total
        discountCode
        discountAmount
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCartItem = /* GraphQL */ `
  query GetCartItem($id: ID!) {
    getCartItem(id: $id) {
      id
      cartId
      cart {
        id
        userId
        sessionId
        subtotal
        tax
        shipping
        total
        discountCode
        discountAmount
        createdAt
        updatedAt
        __typename
      }
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      variantId
      variant {
        id
        productId
        name
        price
        stock
        sku
        createdAt
        updatedAt
        __typename
      }
      quantity
      price
      total
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCartItems = /* GraphQL */ `
  query ListCartItems(
    $filter: ModelCartItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCartItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        cartId
        productId
        variantId
        quantity
        price
        total
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOrder = /* GraphQL */ `
  query GetOrder($id: ID!) {
    getOrder(id: $id) {
      id
      orderNumber
      userId
      user {
        id
        email
        name
        role
        phone
        address
        createdAt
        updatedAt
        __typename
      }
      status
      items {
        nextToken
        __typename
      }
      shippingAddress
      billingAddress
      subtotal
      tax
      shipping
      total
      paymentMethod
      paymentStatus
      paymentId
      contactMethod
      whatsappNumber
      notes
      deliveryDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listOrders = /* GraphQL */ `
  query ListOrders(
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orderNumber
        userId
        status
        shippingAddress
        billingAddress
        subtotal
        tax
        shipping
        total
        paymentMethod
        paymentStatus
        paymentId
        contactMethod
        whatsappNumber
        notes
        deliveryDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOrderItem = /* GraphQL */ `
  query GetOrderItem($id: ID!) {
    getOrderItem(id: $id) {
      id
      orderId
      order {
        id
        orderNumber
        userId
        status
        shippingAddress
        billingAddress
        subtotal
        tax
        shipping
        total
        paymentMethod
        paymentStatus
        paymentId
        contactMethod
        whatsappNumber
        notes
        deliveryDate
        createdAt
        updatedAt
        __typename
      }
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      variantId
      variant {
        id
        productId
        name
        price
        stock
        sku
        createdAt
        updatedAt
        __typename
      }
      quantity
      price
      total
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listOrderItems = /* GraphQL */ `
  query ListOrderItems(
    $filter: ModelOrderItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orderId
        productId
        variantId
        quantity
        price
        total
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getActivity = /* GraphQL */ `
  query GetActivity($id: ID!) {
    getActivity(id: $id) {
      id
      name
      description
      type
      duration
      price
      maxParticipants
      images
      includes
      difficulty
      seasonality
      available
      bookings {
        nextToken
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listActivities = /* GraphQL */ `
  query ListActivities(
    $filter: ModelActivityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listActivities(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        type
        duration
        price
        maxParticipants
        images
        includes
        difficulty
        seasonality
        available
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAccommodation = /* GraphQL */ `
  query GetAccommodation($id: ID!) {
    getAccommodation(id: $id) {
      id
      name
      description
      type
      capacity
      pricePerNight
      images
      amenities
      available
      bookings {
        nextToken
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAccommodations = /* GraphQL */ `
  query ListAccommodations(
    $filter: ModelAccommodationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAccommodations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        type
        capacity
        pricePerNight
        images
        amenities
        available
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBooking = /* GraphQL */ `
  query GetBooking($id: ID!) {
    getBooking(id: $id) {
      id
      userId
      user {
        id
        email
        name
        role
        phone
        address
        createdAt
        updatedAt
        __typename
      }
      bookingNumber
      type
      activityId
      activity {
        id
        name
        description
        type
        duration
        price
        maxParticipants
        images
        includes
        difficulty
        seasonality
        available
        createdAt
        updatedAt
        __typename
      }
      accommodationId
      accommodation {
        id
        name
        description
        type
        capacity
        pricePerNight
        images
        amenities
        available
        createdAt
        updatedAt
        __typename
      }
      startDate
      endDate
      guests
      totalAmount
      status
      paymentStatus
      specialRequests
      confirmationNumber
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBookings = /* GraphQL */ `
  query ListBookings(
    $filter: ModelBookingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBookings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        bookingNumber
        type
        activityId
        accommodationId
        startDate
        endDate
        guests
        totalAmount
        status
        paymentStatus
        specialRequests
        confirmationNumber
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getWorker = /* GraphQL */ `
  query GetWorker($id: ID!) {
    getWorker(id: $id) {
      id
      name
      role
      responsibility
      phone
      address
      status
      tasks {
        nextToken
        __typename
      }
      financialRecords {
        nextToken
        __typename
      }
      loans {
        nextToken
        __typename
      }
      assignedMachinery {
        nextToken
        __typename
      }
      operatingLogs {
        nextToken
        __typename
      }
      bankAccount
      monthlySalary
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listWorkers = /* GraphQL */ `
  query ListWorkers(
    $filter: ModelWorkerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWorkers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        role
        responsibility
        phone
        address
        status
        bankAccount
        monthlySalary
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTask = /* GraphQL */ `
  query GetTask($id: ID!) {
    getTask(id: $id) {
      id
      title
      description
      category
      priority
      status
      area
      estimatedHours
      dueDate
      completedAt
      notes
      photos
      workerId
      worker {
        id
        name
        role
        responsibility
        phone
        address
        status
        bankAccount
        monthlySalary
        createdAt
        updatedAt
        __typename
      }
      subtasks {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTasks = /* GraphQL */ `
  query ListTasks(
    $filter: ModelTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTasks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        description
        category
        priority
        status
        area
        estimatedHours
        dueDate
        completedAt
        notes
        photos
        workerId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTaskSubtaskInstance = /* GraphQL */ `
  query GetTaskSubtaskInstance($id: ID!) {
    getTaskSubtaskInstance(id: $id) {
      id
      taskId
      task {
        id
        title
        description
        category
        priority
        status
        area
        estimatedHours
        dueDate
        completedAt
        notes
        photos
        workerId
        createdAt
        updatedAt
        __typename
      }
      title
      description
      startTime
      endTime
      duration
      area
      priority
      order
      isCompleted
      completedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTaskSubtaskInstances = /* GraphQL */ `
  query ListTaskSubtaskInstances(
    $filter: ModelTaskSubtaskInstanceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTaskSubtaskInstances(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        taskId
        title
        description
        startTime
        endTime
        duration
        area
        priority
        order
        isCompleted
        completedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTaskTemplate = /* GraphQL */ `
  query GetTaskTemplate($id: ID!) {
    getTaskTemplate(id: $id) {
      id
      name
      description
      dayOfWeek
      category
      role
      isActive
      subtasks {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTaskTemplates = /* GraphQL */ `
  query ListTaskTemplates(
    $filter: ModelTaskTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTaskTemplates(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        dayOfWeek
        category
        role
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTaskSubtask = /* GraphQL */ `
  query GetTaskSubtask($id: ID!) {
    getTaskSubtask(id: $id) {
      id
      templateId
      template {
        id
        name
        description
        dayOfWeek
        category
        role
        isActive
        createdAt
        updatedAt
        __typename
      }
      title
      description
      startTime
      endTime
      duration
      area
      priority
      order
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTaskSubtasks = /* GraphQL */ `
  query ListTaskSubtasks(
    $filter: ModelTaskSubtaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTaskSubtasks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        templateId
        title
        description
        startTime
        endTime
        duration
        area
        priority
        order
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getInventory = /* GraphQL */ `
  query GetInventory($id: ID!) {
    getInventory(id: $id) {
      id
      productName
      currentStock
      unit
      location
      harvestDate
      expiryDate
      qualityGrade
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listInventories = /* GraphQL */ `
  query ListInventories(
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInventories(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        productName
        currentStock
        unit
        location
        harvestDate
        expiryDate
        qualityGrade
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getReview = /* GraphQL */ `
  query GetReview($id: ID!) {
    getReview(id: $id) {
      id
      userId
      user {
        id
        email
        name
        role
        phone
        address
        createdAt
        updatedAt
        __typename
      }
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      activityId
      activity {
        id
        name
        description
        type
        duration
        price
        maxParticipants
        images
        includes
        difficulty
        seasonality
        available
        createdAt
        updatedAt
        __typename
      }
      accommodationId
      accommodation {
        id
        name
        description
        type
        capacity
        pricePerNight
        images
        amenities
        available
        createdAt
        updatedAt
        __typename
      }
      rating
      title
      comment
      verified
      helpful
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listReviews = /* GraphQL */ `
  query ListReviews(
    $filter: ModelReviewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listReviews(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        productId
        activityId
        accommodationId
        rating
        title
        comment
        verified
        helpful
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFinancialRecord = /* GraphQL */ `
  query GetFinancialRecord($id: ID!) {
    getFinancialRecord(id: $id) {
      id
      type
      expenseCategory
      incomeCategory
      amount
      description
      date
      workerId
      worker {
        id
        name
        role
        responsibility
        phone
        address
        status
        bankAccount
        monthlySalary
        createdAt
        updatedAt
        __typename
      }
      attachments
      paymentMethod
      referenceNumber
      orderId
      bookingId
      budgetId
      budget {
        id
        name
        description
        startDate
        endDate
        status
        createdAt
        updatedAt
        __typename
      }
      status
      approvedBy
      approvedAt
      isRecurring
      recurringFrequency
      parentTransactionId
      category
      reference
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listFinancialRecords = /* GraphQL */ `
  query ListFinancialRecords(
    $filter: ModelFinancialRecordFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFinancialRecords(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        expenseCategory
        incomeCategory
        amount
        description
        date
        workerId
        attachments
        paymentMethod
        referenceNumber
        orderId
        bookingId
        budgetId
        status
        approvedBy
        approvedAt
        isRecurring
        recurringFrequency
        parentTransactionId
        category
        reference
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getWorkerLoan = /* GraphQL */ `
  query GetWorkerLoan($id: ID!) {
    getWorkerLoan(id: $id) {
      id
      workerId
      worker {
        id
        name
        role
        responsibility
        phone
        address
        status
        bankAccount
        monthlySalary
        createdAt
        updatedAt
        __typename
      }
      amount
      purpose
      interestRate
      issueDate
      dueDate
      status
      totalRepaid
      remainingBalance
      repayments {
        nextToken
        __typename
      }
      agreement
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listWorkerLoans = /* GraphQL */ `
  query ListWorkerLoans(
    $filter: ModelWorkerLoanFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWorkerLoans(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        workerId
        amount
        purpose
        interestRate
        issueDate
        dueDate
        status
        totalRepaid
        remainingBalance
        agreement
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLoanRepayment = /* GraphQL */ `
  query GetLoanRepayment($id: ID!) {
    getLoanRepayment(id: $id) {
      id
      loanId
      loan {
        id
        workerId
        amount
        purpose
        interestRate
        issueDate
        dueDate
        status
        totalRepaid
        remainingBalance
        agreement
        notes
        createdAt
        updatedAt
        __typename
      }
      amount
      date
      method
      notes
      financialRecordId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listLoanRepayments = /* GraphQL */ `
  query ListLoanRepayments(
    $filter: ModelLoanRepaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLoanRepayments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        loanId
        amount
        date
        method
        notes
        financialRecordId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBudget = /* GraphQL */ `
  query GetBudget($id: ID!) {
    getBudget(id: $id) {
      id
      name
      description
      startDate
      endDate
      budgetItems {
        nextToken
        __typename
      }
      transactions {
        nextToken
        __typename
      }
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBudgets = /* GraphQL */ `
  query ListBudgets(
    $filter: ModelBudgetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBudgets(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        startDate
        endDate
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBudgetItem = /* GraphQL */ `
  query GetBudgetItem($id: ID!) {
    getBudgetItem(id: $id) {
      id
      budgetId
      budget {
        id
        name
        description
        startDate
        endDate
        status
        createdAt
        updatedAt
        __typename
      }
      category
      type
      plannedAmount
      actualAmount
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBudgetItems = /* GraphQL */ `
  query ListBudgetItems(
    $filter: ModelBudgetItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBudgetItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        budgetId
        category
        type
        plannedAmount
        actualAmount
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFinancialReport = /* GraphQL */ `
  query GetFinancialReport($id: ID!) {
    getFinancialReport(id: $id) {
      id
      name
      type
      startDate
      endDate
      reportData
      categories
      workers
      status
      generatedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listFinancialReports = /* GraphQL */ `
  query ListFinancialReports(
    $filter: ModelFinancialReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFinancialReports(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        type
        startDate
        endDate
        reportData
        categories
        workers
        status
        generatedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getNewsletter = /* GraphQL */ `
  query GetNewsletter($id: ID!) {
    getNewsletter(id: $id) {
      id
      email
      name
      subscribed
      preferences
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listNewsletters = /* GraphQL */ `
  query ListNewsletters(
    $filter: ModelNewsletterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNewsletters(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        email
        name
        subscribed
        preferences
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFAQ = /* GraphQL */ `
  query GetFAQ($id: ID!) {
    getFAQ(id: $id) {
      id
      question
      answer
      category
      order
      active
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listFAQS = /* GraphQL */ `
  query ListFAQS(
    $filter: ModelFAQFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFAQS(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        question
        answer
        category
        order
        active
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getGallery = /* GraphQL */ `
  query GetGallery($id: ID!) {
    getGallery(id: $id) {
      id
      title
      description
      coverImage
      category
      isActive
      displayOrder
      date
      location
      images {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listGalleries = /* GraphQL */ `
  query ListGalleries(
    $filter: ModelGalleryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGalleries(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        description
        coverImage
        category
        isActive
        displayOrder
        date
        location
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getGalleryImage = /* GraphQL */ `
  query GetGalleryImage($id: ID!) {
    getGalleryImage(id: $id) {
      id
      galleryId
      gallery {
        id
        title
        description
        coverImage
        category
        isActive
        displayOrder
        date
        location
        createdAt
        updatedAt
        __typename
      }
      originalUrl
      thumbnailUrl
      altText
      caption
      order
      width
      height
      fileSize
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listGalleryImages = /* GraphQL */ `
  query ListGalleryImages(
    $filter: ModelGalleryImageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGalleryImages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        galleryId
        originalUrl
        thumbnailUrl
        altText
        caption
        order
        width
        height
        fileSize
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserFavorite = /* GraphQL */ `
  query GetUserFavorite($id: ID!) {
    getUserFavorite(id: $id) {
      id
      userId
      user {
        id
        email
        name
        role
        phone
        address
        createdAt
        updatedAt
        __typename
      }
      productId
      product {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserFavorites = /* GraphQL */ `
  query ListUserFavorites(
    $filter: ModelUserFavoriteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserFavorites(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        productId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBlog = /* GraphQL */ `
  query GetBlog($id: ID!) {
    getBlog(id: $id) {
      id
      title
      slug
      description
      content
      thumbnailImage
      thumbnailImageAlt
      tags {
        nextToken
        __typename
      }
      status
      isFeatured
      featuredOrder
      viewCount
      estimatedReadTime
      metaTitle
      metaDescription
      authorId
      author {
        id
        email
        name
        role
        phone
        address
        createdAt
        updatedAt
        __typename
      }
      sections {
        nextToken
        __typename
      }
      publishedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBlogs = /* GraphQL */ `
  query ListBlogs(
    $filter: ModelBlogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBlogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        slug
        description
        content
        thumbnailImage
        thumbnailImageAlt
        status
        isFeatured
        featuredOrder
        viewCount
        estimatedReadTime
        metaTitle
        metaDescription
        authorId
        publishedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBlogSection = /* GraphQL */ `
  query GetBlogSection($id: ID!) {
    getBlogSection(id: $id) {
      id
      blogId
      blog {
        id
        title
        slug
        description
        content
        thumbnailImage
        thumbnailImageAlt
        status
        isFeatured
        featuredOrder
        viewCount
        estimatedReadTime
        metaTitle
        metaDescription
        authorId
        publishedAt
        createdAt
        updatedAt
        __typename
      }
      type
      order
      title
      content
      media {
        nextToken
        __typename
      }
      settings
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBlogSections = /* GraphQL */ `
  query ListBlogSections(
    $filter: ModelBlogSectionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBlogSections(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        blogId
        type
        order
        title
        content
        settings
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBlogMedia = /* GraphQL */ `
  query GetBlogMedia($id: ID!) {
    getBlogMedia(id: $id) {
      id
      sectionId
      section {
        id
        blogId
        type
        order
        title
        content
        settings
        createdAt
        updatedAt
        __typename
      }
      type
      originalUrl
      thumbnailUrl
      altText
      caption
      order
      width
      height
      fileSize
      duration
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBlogMedias = /* GraphQL */ `
  query ListBlogMedias(
    $filter: ModelBlogMediaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBlogMedias(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        sectionId
        type
        originalUrl
        thumbnailUrl
        altText
        caption
        order
        width
        height
        fileSize
        duration
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBlogTag = /* GraphQL */ `
  query GetBlogTag($id: ID!) {
    getBlogTag(id: $id) {
      id
      name
      slug
      description
      color
      blogs {
        nextToken
        __typename
      }
      usageCount
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBlogTags = /* GraphQL */ `
  query ListBlogTags(
    $filter: ModelBlogTagFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBlogTags(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        slug
        description
        color
        usageCount
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getNewsletterSubscription = /* GraphQL */ `
  query GetNewsletterSubscription($id: ID!) {
    getNewsletterSubscription(id: $id) {
      id
      email
      isActive
      subscribedAt
      unsubscribedAt
      source
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listNewsletterSubscriptions = /* GraphQL */ `
  query ListNewsletterSubscriptions(
    $filter: ModelNewsletterSubscriptionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNewsletterSubscriptions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        isActive
        subscribedAt
        unsubscribedAt
        source
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMachinery = /* GraphQL */ `
  query GetMachinery($id: ID!) {
    getMachinery(id: $id) {
      id
      name
      category
      brand
      model
      serialNumber
      purchaseStatus
      purchaseDate
      purchasePrice
      supplier
      warranty
      warrantyExpiry
      status
      condition
      currentValue
      location
      maintenanceCycleType
      maintenanceCycleDays
      maintenanceHours
      lastMaintenanceDate
      nextMaintenanceDate
      totalOperatingHours
      assignedWorkerId
      assignedWorker {
        id
        name
        role
        responsibility
        phone
        address
        status
        bankAccount
        monthlySalary
        createdAt
        updatedAt
        __typename
      }
      assignedArea
      totalMaintenanceCost
      totalOperatingCost
      fuelConsumption
      images
      documents
      notes
      specifications
      maintenanceRecords {
        nextToken
        __typename
      }
      operatingLogs {
        nextToken
        __typename
      }
      depreciationRecords {
        nextToken
        __typename
      }
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listMachinery = /* GraphQL */ `
  query ListMachinery(
    $filter: ModelMachineryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMachinery(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        category
        brand
        model
        serialNumber
        purchaseStatus
        purchaseDate
        purchasePrice
        supplier
        warranty
        warrantyExpiry
        status
        condition
        currentValue
        location
        maintenanceCycleType
        maintenanceCycleDays
        maintenanceHours
        lastMaintenanceDate
        nextMaintenanceDate
        totalOperatingHours
        assignedWorkerId
        assignedArea
        totalMaintenanceCost
        totalOperatingCost
        fuelConsumption
        images
        documents
        notes
        specifications
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMaintenanceRecord = /* GraphQL */ `
  query GetMaintenanceRecord($id: ID!) {
    getMaintenanceRecord(id: $id) {
      id
      machineryId
      machinery {
        id
        name
        category
        brand
        model
        serialNumber
        purchaseStatus
        purchaseDate
        purchasePrice
        supplier
        warranty
        warrantyExpiry
        status
        condition
        currentValue
        location
        maintenanceCycleType
        maintenanceCycleDays
        maintenanceHours
        lastMaintenanceDate
        nextMaintenanceDate
        totalOperatingHours
        assignedWorkerId
        assignedArea
        totalMaintenanceCost
        totalOperatingCost
        fuelConsumption
        images
        documents
        notes
        specifications
        isActive
        createdAt
        updatedAt
        __typename
      }
      type
      date
      operatingHoursAtMaintenance
      description
      serviceProvider
      performedBy
      cost
      partsReplaced
      nextScheduledDate
      nextScheduledHours
      images
      invoices
      notes
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listMaintenanceRecords = /* GraphQL */ `
  query ListMaintenanceRecords(
    $filter: ModelMaintenanceRecordFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMaintenanceRecords(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        machineryId
        type
        date
        operatingHoursAtMaintenance
        description
        serviceProvider
        performedBy
        cost
        partsReplaced
        nextScheduledDate
        nextScheduledHours
        images
        invoices
        notes
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOperatingLog = /* GraphQL */ `
  query GetOperatingLog($id: ID!) {
    getOperatingLog(id: $id) {
      id
      machineryId
      machinery {
        id
        name
        category
        brand
        model
        serialNumber
        purchaseStatus
        purchaseDate
        purchasePrice
        supplier
        warranty
        warrantyExpiry
        status
        condition
        currentValue
        location
        maintenanceCycleType
        maintenanceCycleDays
        maintenanceHours
        lastMaintenanceDate
        nextMaintenanceDate
        totalOperatingHours
        assignedWorkerId
        assignedArea
        totalMaintenanceCost
        totalOperatingCost
        fuelConsumption
        images
        documents
        notes
        specifications
        isActive
        createdAt
        updatedAt
        __typename
      }
      date
      operatorId
      operator {
        id
        name
        role
        responsibility
        phone
        address
        status
        bankAccount
        monthlySalary
        createdAt
        updatedAt
        __typename
      }
      startTime
      endTime
      hoursUsed
      area
      purpose
      fuelUsed
      fuelCost
      odometerStart
      odometerEnd
      issues
      performanceRating
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listOperatingLogs = /* GraphQL */ `
  query ListOperatingLogs(
    $filter: ModelOperatingLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOperatingLogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        machineryId
        date
        operatorId
        startTime
        endTime
        hoursUsed
        area
        purpose
        fuelUsed
        fuelCost
        odometerStart
        odometerEnd
        issues
        performanceRating
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMachineryDepreciation = /* GraphQL */ `
  query GetMachineryDepreciation($id: ID!) {
    getMachineryDepreciation(id: $id) {
      id
      machineryId
      machinery {
        id
        name
        category
        brand
        model
        serialNumber
        purchaseStatus
        purchaseDate
        purchasePrice
        supplier
        warranty
        warrantyExpiry
        status
        condition
        currentValue
        location
        maintenanceCycleType
        maintenanceCycleDays
        maintenanceHours
        lastMaintenanceDate
        nextMaintenanceDate
        totalOperatingHours
        assignedWorkerId
        assignedArea
        totalMaintenanceCost
        totalOperatingCost
        fuelConsumption
        images
        documents
        notes
        specifications
        isActive
        createdAt
        updatedAt
        __typename
      }
      year
      startingValue
      depreciationAmount
      endingValue
      depreciationMethod
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listMachineryDepreciations = /* GraphQL */ `
  query ListMachineryDepreciations(
    $filter: ModelMachineryDepreciationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMachineryDepreciations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        machineryId
        year
        startingValue
        depreciationAmount
        endingValue
        depreciationMethod
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSupplier = /* GraphQL */ `
  query GetSupplier($id: ID!) {
    getSupplier(id: $id) {
      id
      name
      contactPerson
      phone
      email
      address
      supplierType
      rating
      isActive
      notes
      plantings {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSuppliers = /* GraphQL */ `
  query ListSuppliers(
    $filter: ModelSupplierFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSuppliers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        contactPerson
        phone
        email
        address
        supplierType
        rating
        isActive
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPlanting = /* GraphQL */ `
  query GetPlanting($id: ID!) {
    getPlanting(id: $id) {
      id
      type
      name
      variety
      zone
      location
      plantingDate
      expectedHarvestDate
      actualHarvestDate
      status
      healthStatus
      area
      waterSchedule
      lastPruned
      lastFertilized
      lastWatered
      notes
      images
      initialQuantity
      quantityUnit
      survivedQuantity
      costPerUnit
      totalCost
      currency
      supplierId
      supplier {
        id
        name
        contactPerson
        phone
        email
        address
        supplierType
        rating
        isActive
        notes
        createdAt
        updatedAt
        __typename
      }
      yieldRecords {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPlantings = /* GraphQL */ `
  query ListPlantings(
    $filter: ModelPlantingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPlantings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        type
        name
        variety
        zone
        location
        plantingDate
        expectedHarvestDate
        actualHarvestDate
        status
        healthStatus
        area
        waterSchedule
        lastPruned
        lastFertilized
        lastWatered
        notes
        images
        initialQuantity
        quantityUnit
        survivedQuantity
        costPerUnit
        totalCost
        currency
        supplierId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getYieldRecord = /* GraphQL */ `
  query GetYieldRecord($id: ID!) {
    getYieldRecord(id: $id) {
      id
      plantingId
      planting {
        id
        type
        name
        variety
        zone
        location
        plantingDate
        expectedHarvestDate
        actualHarvestDate
        status
        healthStatus
        area
        waterSchedule
        lastPruned
        lastFertilized
        lastWatered
        notes
        images
        initialQuantity
        quantityUnit
        survivedQuantity
        costPerUnit
        totalCost
        currency
        supplierId
        createdAt
        updatedAt
        __typename
      }
      date
      quantity
      unit
      quality
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listYieldRecords = /* GraphQL */ `
  query ListYieldRecords(
    $filter: ModelYieldRecordFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listYieldRecords(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        plantingId
        date
        quantity
        unit
        quality
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBlogBlogTag = /* GraphQL */ `
  query GetBlogBlogTag($id: ID!) {
    getBlogBlogTag(id: $id) {
      id
      blogId
      blogTagId
      blog {
        id
        title
        slug
        description
        content
        thumbnailImage
        thumbnailImageAlt
        status
        isFeatured
        featuredOrder
        viewCount
        estimatedReadTime
        metaTitle
        metaDescription
        authorId
        publishedAt
        createdAt
        updatedAt
        __typename
      }
      blogTag {
        id
        name
        slug
        description
        color
        usageCount
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBlogBlogTags = /* GraphQL */ `
  query ListBlogBlogTags(
    $filter: ModelBlogBlogTagFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBlogBlogTags(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        blogId
        blogTagId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const productsByCategoryId = /* GraphQL */ `
  query ProductsByCategoryId(
    $categoryId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productsByCategoryId(
      categoryId: $categoryId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        shortDescription
        categoryId
        price
        discountPrice
        stock
        sku
        weight
        dimensions
        isActive
        isFeatured
        tags
        nutritionalInfo
        farmingMethod
        harvestDate
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const productImagesByProductId = /* GraphQL */ `
  query ProductImagesByProductId(
    $productId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelProductImageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productImagesByProductId(
      productId: $productId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productId
        url
        altText
        isPrimary
        order
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const productVideosByProductId = /* GraphQL */ `
  query ProductVideosByProductId(
    $productId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelProductVideoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productVideosByProductId(
      productId: $productId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productId
        url
        title
        description
        thumbnail
        duration
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const productVariantsByProductId = /* GraphQL */ `
  query ProductVariantsByProductId(
    $productId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelProductVariantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productVariantsByProductId(
      productId: $productId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productId
        name
        price
        stock
        sku
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const featuredProductsByProductId = /* GraphQL */ `
  query FeaturedProductsByProductId(
    $productId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelFeaturedProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    featuredProductsByProductId(
      productId: $productId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productId
        displayOrder
        isActive
        startDate
        endDate
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const cartsByUserId = /* GraphQL */ `
  query CartsByUserId(
    $userId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCartFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cartsByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        sessionId
        subtotal
        tax
        shipping
        total
        discountCode
        discountAmount
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const cartItemsByCartId = /* GraphQL */ `
  query CartItemsByCartId(
    $cartId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCartItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cartItemsByCartId(
      cartId: $cartId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cartId
        productId
        variantId
        quantity
        price
        total
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const cartItemsByProductId = /* GraphQL */ `
  query CartItemsByProductId(
    $productId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCartItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cartItemsByProductId(
      productId: $productId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cartId
        productId
        variantId
        quantity
        price
        total
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const cartItemsByVariantId = /* GraphQL */ `
  query CartItemsByVariantId(
    $variantId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCartItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cartItemsByVariantId(
      variantId: $variantId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cartId
        productId
        variantId
        quantity
        price
        total
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const ordersByUserId = /* GraphQL */ `
  query OrdersByUserId(
    $userId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ordersByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orderNumber
        userId
        status
        shippingAddress
        billingAddress
        subtotal
        tax
        shipping
        total
        paymentMethod
        paymentStatus
        paymentId
        contactMethod
        whatsappNumber
        notes
        deliveryDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const orderItemsByOrderId = /* GraphQL */ `
  query OrderItemsByOrderId(
    $orderId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelOrderItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    orderItemsByOrderId(
      orderId: $orderId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orderId
        productId
        variantId
        quantity
        price
        total
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const orderItemsByProductId = /* GraphQL */ `
  query OrderItemsByProductId(
    $productId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelOrderItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    orderItemsByProductId(
      productId: $productId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orderId
        productId
        variantId
        quantity
        price
        total
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const orderItemsByVariantId = /* GraphQL */ `
  query OrderItemsByVariantId(
    $variantId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelOrderItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    orderItemsByVariantId(
      variantId: $variantId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orderId
        productId
        variantId
        quantity
        price
        total
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const bookingsByUserId = /* GraphQL */ `
  query BookingsByUserId(
    $userId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelBookingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bookingsByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        bookingNumber
        type
        activityId
        accommodationId
        startDate
        endDate
        guests
        totalAmount
        status
        paymentStatus
        specialRequests
        confirmationNumber
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const bookingsByActivityId = /* GraphQL */ `
  query BookingsByActivityId(
    $activityId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelBookingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bookingsByActivityId(
      activityId: $activityId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        bookingNumber
        type
        activityId
        accommodationId
        startDate
        endDate
        guests
        totalAmount
        status
        paymentStatus
        specialRequests
        confirmationNumber
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const bookingsByAccommodationId = /* GraphQL */ `
  query BookingsByAccommodationId(
    $accommodationId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelBookingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bookingsByAccommodationId(
      accommodationId: $accommodationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        bookingNumber
        type
        activityId
        accommodationId
        startDate
        endDate
        guests
        totalAmount
        status
        paymentStatus
        specialRequests
        confirmationNumber
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const tasksByWorkerId = /* GraphQL */ `
  query TasksByWorkerId(
    $workerId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    tasksByWorkerId(
      workerId: $workerId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        category
        priority
        status
        area
        estimatedHours
        dueDate
        completedAt
        notes
        photos
        workerId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const taskSubtaskInstancesByTaskId = /* GraphQL */ `
  query TaskSubtaskInstancesByTaskId(
    $taskId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelTaskSubtaskInstanceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    taskSubtaskInstancesByTaskId(
      taskId: $taskId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        taskId
        title
        description
        startTime
        endTime
        duration
        area
        priority
        order
        isCompleted
        completedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const taskSubtasksByTemplateId = /* GraphQL */ `
  query TaskSubtasksByTemplateId(
    $templateId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelTaskSubtaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    taskSubtasksByTemplateId(
      templateId: $templateId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        templateId
        title
        description
        startTime
        endTime
        duration
        area
        priority
        order
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const reviewsByUserId = /* GraphQL */ `
  query ReviewsByUserId(
    $userId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelReviewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reviewsByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        productId
        activityId
        accommodationId
        rating
        title
        comment
        verified
        helpful
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const reviewsByProductId = /* GraphQL */ `
  query ReviewsByProductId(
    $productId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelReviewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reviewsByProductId(
      productId: $productId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        productId
        activityId
        accommodationId
        rating
        title
        comment
        verified
        helpful
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const reviewsByActivityId = /* GraphQL */ `
  query ReviewsByActivityId(
    $activityId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelReviewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reviewsByActivityId(
      activityId: $activityId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        productId
        activityId
        accommodationId
        rating
        title
        comment
        verified
        helpful
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const reviewsByAccommodationId = /* GraphQL */ `
  query ReviewsByAccommodationId(
    $accommodationId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelReviewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reviewsByAccommodationId(
      accommodationId: $accommodationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        productId
        activityId
        accommodationId
        rating
        title
        comment
        verified
        helpful
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const financialRecordsByWorkerId = /* GraphQL */ `
  query FinancialRecordsByWorkerId(
    $workerId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelFinancialRecordFilterInput
    $limit: Int
    $nextToken: String
  ) {
    financialRecordsByWorkerId(
      workerId: $workerId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        expenseCategory
        incomeCategory
        amount
        description
        date
        workerId
        attachments
        paymentMethod
        referenceNumber
        orderId
        bookingId
        budgetId
        status
        approvedBy
        approvedAt
        isRecurring
        recurringFrequency
        parentTransactionId
        category
        reference
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const financialRecordsByBudgetId = /* GraphQL */ `
  query FinancialRecordsByBudgetId(
    $budgetId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelFinancialRecordFilterInput
    $limit: Int
    $nextToken: String
  ) {
    financialRecordsByBudgetId(
      budgetId: $budgetId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        expenseCategory
        incomeCategory
        amount
        description
        date
        workerId
        attachments
        paymentMethod
        referenceNumber
        orderId
        bookingId
        budgetId
        status
        approvedBy
        approvedAt
        isRecurring
        recurringFrequency
        parentTransactionId
        category
        reference
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const workerLoansByWorkerId = /* GraphQL */ `
  query WorkerLoansByWorkerId(
    $workerId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelWorkerLoanFilterInput
    $limit: Int
    $nextToken: String
  ) {
    workerLoansByWorkerId(
      workerId: $workerId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        workerId
        amount
        purpose
        interestRate
        issueDate
        dueDate
        status
        totalRepaid
        remainingBalance
        agreement
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const loanRepaymentsByLoanId = /* GraphQL */ `
  query LoanRepaymentsByLoanId(
    $loanId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelLoanRepaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    loanRepaymentsByLoanId(
      loanId: $loanId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        loanId
        amount
        date
        method
        notes
        financialRecordId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const budgetItemsByBudgetId = /* GraphQL */ `
  query BudgetItemsByBudgetId(
    $budgetId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelBudgetItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    budgetItemsByBudgetId(
      budgetId: $budgetId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        budgetId
        category
        type
        plannedAmount
        actualAmount
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const galleryImagesByGalleryId = /* GraphQL */ `
  query GalleryImagesByGalleryId(
    $galleryId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelGalleryImageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    galleryImagesByGalleryId(
      galleryId: $galleryId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        galleryId
        originalUrl
        thumbnailUrl
        altText
        caption
        order
        width
        height
        fileSize
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userFavoritesByUserId = /* GraphQL */ `
  query UserFavoritesByUserId(
    $userId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserFavoriteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userFavoritesByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        productId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userFavoritesByProductId = /* GraphQL */ `
  query UserFavoritesByProductId(
    $productId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserFavoriteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userFavoritesByProductId(
      productId: $productId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        productId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const blogsBySlug = /* GraphQL */ `
  query BlogsBySlug(
    $slug: String!
    $sortDirection: ModelSortDirection
    $filter: ModelBlogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    blogsBySlug(
      slug: $slug
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        slug
        description
        content
        thumbnailImage
        thumbnailImageAlt
        status
        isFeatured
        featuredOrder
        viewCount
        estimatedReadTime
        metaTitle
        metaDescription
        authorId
        publishedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const blogsByAuthorId = /* GraphQL */ `
  query BlogsByAuthorId(
    $authorId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelBlogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    blogsByAuthorId(
      authorId: $authorId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        slug
        description
        content
        thumbnailImage
        thumbnailImageAlt
        status
        isFeatured
        featuredOrder
        viewCount
        estimatedReadTime
        metaTitle
        metaDescription
        authorId
        publishedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const blogSectionsByBlogId = /* GraphQL */ `
  query BlogSectionsByBlogId(
    $blogId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelBlogSectionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    blogSectionsByBlogId(
      blogId: $blogId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        blogId
        type
        order
        title
        content
        settings
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const blogMediasBySectionId = /* GraphQL */ `
  query BlogMediasBySectionId(
    $sectionId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelBlogMediaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    blogMediasBySectionId(
      sectionId: $sectionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        sectionId
        type
        originalUrl
        thumbnailUrl
        altText
        caption
        order
        width
        height
        fileSize
        duration
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const blogTagsBySlug = /* GraphQL */ `
  query BlogTagsBySlug(
    $slug: String!
    $sortDirection: ModelSortDirection
    $filter: ModelBlogTagFilterInput
    $limit: Int
    $nextToken: String
  ) {
    blogTagsBySlug(
      slug: $slug
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        slug
        description
        color
        usageCount
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const newsletterSubscriptionsByEmail = /* GraphQL */ `
  query NewsletterSubscriptionsByEmail(
    $email: String!
    $sortDirection: ModelSortDirection
    $filter: ModelNewsletterSubscriptionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    newsletterSubscriptionsByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        isActive
        subscribedAt
        unsubscribedAt
        source
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const machineryBySerialNumber = /* GraphQL */ `
  query MachineryBySerialNumber(
    $serialNumber: String!
    $sortDirection: ModelSortDirection
    $filter: ModelMachineryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    machineryBySerialNumber(
      serialNumber: $serialNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        category
        brand
        model
        serialNumber
        purchaseStatus
        purchaseDate
        purchasePrice
        supplier
        warranty
        warrantyExpiry
        status
        condition
        currentValue
        location
        maintenanceCycleType
        maintenanceCycleDays
        maintenanceHours
        lastMaintenanceDate
        nextMaintenanceDate
        totalOperatingHours
        assignedWorkerId
        assignedArea
        totalMaintenanceCost
        totalOperatingCost
        fuelConsumption
        images
        documents
        notes
        specifications
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const machineryByAssignedWorkerId = /* GraphQL */ `
  query MachineryByAssignedWorkerId(
    $assignedWorkerId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelMachineryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    machineryByAssignedWorkerId(
      assignedWorkerId: $assignedWorkerId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        category
        brand
        model
        serialNumber
        purchaseStatus
        purchaseDate
        purchasePrice
        supplier
        warranty
        warrantyExpiry
        status
        condition
        currentValue
        location
        maintenanceCycleType
        maintenanceCycleDays
        maintenanceHours
        lastMaintenanceDate
        nextMaintenanceDate
        totalOperatingHours
        assignedWorkerId
        assignedArea
        totalMaintenanceCost
        totalOperatingCost
        fuelConsumption
        images
        documents
        notes
        specifications
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const maintenanceRecordsByMachineryId = /* GraphQL */ `
  query MaintenanceRecordsByMachineryId(
    $machineryId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelMaintenanceRecordFilterInput
    $limit: Int
    $nextToken: String
  ) {
    maintenanceRecordsByMachineryId(
      machineryId: $machineryId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        machineryId
        type
        date
        operatingHoursAtMaintenance
        description
        serviceProvider
        performedBy
        cost
        partsReplaced
        nextScheduledDate
        nextScheduledHours
        images
        invoices
        notes
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const operatingLogsByMachineryId = /* GraphQL */ `
  query OperatingLogsByMachineryId(
    $machineryId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelOperatingLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    operatingLogsByMachineryId(
      machineryId: $machineryId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        machineryId
        date
        operatorId
        startTime
        endTime
        hoursUsed
        area
        purpose
        fuelUsed
        fuelCost
        odometerStart
        odometerEnd
        issues
        performanceRating
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const operatingLogsByOperatorId = /* GraphQL */ `
  query OperatingLogsByOperatorId(
    $operatorId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelOperatingLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    operatingLogsByOperatorId(
      operatorId: $operatorId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        machineryId
        date
        operatorId
        startTime
        endTime
        hoursUsed
        area
        purpose
        fuelUsed
        fuelCost
        odometerStart
        odometerEnd
        issues
        performanceRating
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const machineryDepreciationsByMachineryId = /* GraphQL */ `
  query MachineryDepreciationsByMachineryId(
    $machineryId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelMachineryDepreciationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    machineryDepreciationsByMachineryId(
      machineryId: $machineryId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        machineryId
        year
        startingValue
        depreciationAmount
        endingValue
        depreciationMethod
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const plantingsBySupplierId = /* GraphQL */ `
  query PlantingsBySupplierId(
    $supplierId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelPlantingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    plantingsBySupplierId(
      supplierId: $supplierId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        name
        variety
        zone
        location
        plantingDate
        expectedHarvestDate
        actualHarvestDate
        status
        healthStatus
        area
        waterSchedule
        lastPruned
        lastFertilized
        lastWatered
        notes
        images
        initialQuantity
        quantityUnit
        survivedQuantity
        costPerUnit
        totalCost
        currency
        supplierId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const yieldRecordsByPlantingId = /* GraphQL */ `
  query YieldRecordsByPlantingId(
    $plantingId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelYieldRecordFilterInput
    $limit: Int
    $nextToken: String
  ) {
    yieldRecordsByPlantingId(
      plantingId: $plantingId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        plantingId
        date
        quantity
        unit
        quality
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const blogBlogTagsByBlogId = /* GraphQL */ `
  query BlogBlogTagsByBlogId(
    $blogId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelBlogBlogTagFilterInput
    $limit: Int
    $nextToken: String
  ) {
    blogBlogTagsByBlogId(
      blogId: $blogId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        blogId
        blogTagId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const blogBlogTagsByBlogTagId = /* GraphQL */ `
  query BlogBlogTagsByBlogTagId(
    $blogTagId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelBlogBlogTagFilterInput
    $limit: Int
    $nextToken: String
  ) {
    blogBlogTagsByBlogTagId(
      blogTagId: $blogTagId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        blogId
        blogTagId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSuggestionCategory = /* GraphQL */ `
  query GetSuggestionCategory($id: ID!) {
    getSuggestionCategory(id: $id) {
      id
      name
      displayName
      description
      icon
      color
      isActive
      order
      createdAt
      updatedAt
      suggestions {
        nextToken
        __typename
      }
      stats {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listSuggestionCategories = /* GraphQL */ `
  query ListSuggestionCategories(
    $filter: ModelSuggestionCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSuggestionCategories(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        displayName
        description
        icon
        color
        isActive
        order
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const suggestionCategoriesByName = /* GraphQL */ `
  query SuggestionCategoriesByName(
    $name: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSuggestionCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    suggestionCategoriesByName(
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        displayName
        description
        icon
        color
        isActive
        order
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getWorkerRole = /* GraphQL */ `
  query GetWorkerRole($id: ID!) {
    getWorkerRole(id: $id) {
      id
      name
      displayName
      description
      isActive
      order
      createdAt
      updatedAt
      suggestions {
        nextToken
        __typename
      }
      stats {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listWorkerRoles = /* GraphQL */ `
  query ListWorkerRoles(
    $filter: ModelWorkerRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWorkerRoles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        displayName
        description
        isActive
        order
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const workerRolesByName = /* GraphQL */ `
  query WorkerRolesByName(
    $name: String!
    $sortDirection: ModelSortDirection
    $filter: ModelWorkerRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    workerRolesByName(
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        displayName
        description
        isActive
        order
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSubtaskSuggestion = /* GraphQL */ `
  query GetSubtaskSuggestion($id: ID!) {
    getSubtaskSuggestion(id: $id) {
      id
      title
      description
      duration
      priority
      estimatedCost
      requiredSkills
      tools
      safetyNotes
      order
      isActive
      createdAt
      updatedAt
      categoryId
      roleId
      category {
        id
        name
        displayName
        description
        icon
        color
        isActive
        order
        createdAt
        updatedAt
        __typename
      }
      role {
        id
        name
        displayName
        description
        isActive
        order
        createdAt
        updatedAt
        __typename
      }
      usageCount
      lastUsed
      __typename
    }
  }
`;
export const listSubtaskSuggestions = /* GraphQL */ `
  query ListSubtaskSuggestions(
    $filter: ModelSubtaskSuggestionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubtaskSuggestions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        duration
        priority
        estimatedCost
        requiredSkills
        tools
        safetyNotes
        order
        isActive
        createdAt
        updatedAt
        categoryId
        roleId
        usageCount
        lastUsed
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const subtaskSuggestionsByCategoryId = /* GraphQL */ `
  query SubtaskSuggestionsByCategoryId(
    $categoryId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSubtaskSuggestionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    subtaskSuggestionsByCategoryId(
      categoryId: $categoryId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        duration
        priority
        estimatedCost
        requiredSkills
        tools
        safetyNotes
        order
        isActive
        createdAt
        updatedAt
        categoryId
        roleId
        usageCount
        lastUsed
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const subtaskSuggestionsByRoleId = /* GraphQL */ `
  query SubtaskSuggestionsByRoleId(
    $roleId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSubtaskSuggestionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    subtaskSuggestionsByRoleId(
      roleId: $roleId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        duration
        priority
        estimatedCost
        requiredSkills
        tools
        safetyNotes
        order
        isActive
        createdAt
        updatedAt
        categoryId
        roleId
        usageCount
        lastUsed
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSuggestionStats = /* GraphQL */ `
  query GetSuggestionStats($id: ID!) {
    getSuggestionStats(id: $id) {
      id
      categoryId
      roleId
      totalSuggestions
      activeSuggestions
      mostUsedSuggestion
      averageUsage
      lastUpdated
      category {
        id
        name
        displayName
        description
        icon
        color
        isActive
        order
        createdAt
        updatedAt
        __typename
      }
      role {
        id
        name
        displayName
        description
        isActive
        order
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSuggestionStats = /* GraphQL */ `
  query ListSuggestionStats(
    $filter: ModelSuggestionStatsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSuggestionStats(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        categoryId
        roleId
        totalSuggestions
        activeSuggestions
        mostUsedSuggestion
        averageUsage
        lastUpdated
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const suggestionStatsByCategoryId = /* GraphQL */ `
  query SuggestionStatsByCategoryId(
    $categoryId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSuggestionStatsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    suggestionStatsByCategoryId(
      categoryId: $categoryId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        categoryId
        roleId
        totalSuggestions
        activeSuggestions
        mostUsedSuggestion
        averageUsage
        lastUpdated
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const suggestionStatsByRoleId = /* GraphQL */ `
  query SuggestionStatsByRoleId(
    $roleId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSuggestionStatsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    suggestionStatsByRoleId(
      roleId: $roleId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        categoryId
        roleId
        totalSuggestions
        activeSuggestions
        mostUsedSuggestion
        averageUsage
        lastUpdated
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
